var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuthModalLoading)?_c('div',{staticClass:"auth-loading-modal"},[_c('LoadingIcon',{attrs:{"isLoading":_vm.isAuthModalLoading}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }